// routes/config/index.ts
/**
 * Route Configuration - Barrel Export
 * Aggregates all route configurations into a single array
 */

import { authRoutes } from './authRoutes';
import { publicRoutes } from './publicRoutes';
import { playerRoutes } from './playerRoutes';
import { tournamentRoutes } from './tournamentRoutes';
import { staffRoutes } from './staffRoutes';
import { adminRoutes } from './adminRoutes';
import type { RouteConfig } from '../types';

// Export individual route groups
export { authRoutes } from './authRoutes';
export { publicRoutes } from './publicRoutes';
export { playerRoutes } from './playerRoutes';
export { tournamentRoutes } from './tournamentRoutes';
export { staffRoutes } from './staffRoutes';
export { adminRoutes } from './adminRoutes';

// Aggregate all routes
export const allRoutes: RouteConfig[] = [
  ...authRoutes,
  ...publicRoutes,
  ...playerRoutes,
  ...staffRoutes,
  ...tournamentRoutes,
  ...adminRoutes,
];
